<form class="form-container" (submit)="$event.preventDefault()">
  <div class="form-header">
    <h2>{{ heading }}</h2>
    <ng-content select="[header-actions]"></ng-content>
  </div>

  <!-- Content projection for form controls -->
  <ng-content></ng-content>
</form>
